export const enum NotificationEndPoints {
  GET_NOTIFICATIONS = '/notifications/all',
  UPDATE_ALL_NOTIFICATION_READ = '/notifications/mark-all-read',
  UPDATE_NOTIFICATION_READ = '/mark-read',
  BASE_NOTIFICATION = '/notifications',
  GET_AUDIT_REPORTS_AGAINST_RANDOM_STRING = '/audits/randomString',
  GET_REAL_NOTIFICATION = '/api/v1/event/subscribe'
}
